// import React, { useState } from 'react';
// import { uploadData, updateCollection, deleteCollection } from '@utilities/auth';
// import  { resortData } from './menu/manu-resort';
// import { resortData } from './menu/pamil-stay';
// import { resortData } from './menu/chandan-hotel';
// import NestedList from '@src/app/components/NestedList';
import { Button } from '@mui/material';
// import List from '@src/app/components/NestedList/List';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs, { Dayjs } from 'dayjs';
// import moment from 'moment';

function UploadData() {
  const handleUpdateResData = () => {
    // var connectionName = "restaurants"; // stage: change it to restaurants for production
    // var docId = "Y5eQ9hNmlqdYMVLcqIgT"; // Test Restaurants - Chandan Hotel restaurant
    // var docId = "Sk5sDObw3aJSTnUnVlEG"; // Prod Restaurants - Chandan Hotel restaurant
    
    // var keyMenu = "menu"; //
    // var keyCatOrder = "categoryOrder"; //
    // var keyRoomType = "roomType"; //
    console.log('Nice! - Commented code');
    // updateCollection(connectionName, docId, keyMenu, resortData?.menu);
    // updateCollection(connectionName, docId, keyCatOrder, resortData?.categoryOrder);
    // updateCollection(connectionName, docId, keyRoomType, resortData?.roomType);
  }

  return (
    <div>
      <Button
          fullWidth
          onClick={() => handleUpdateResData()}
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
      >
          Update Collection Menu & Category
      </Button>
    </div>
  );
}

export default UploadData;
